import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=756ce96e&"
import script from "./Artwork.vue?vue&type=script&lang=ts&"
export * from "./Artwork.vue?vue&type=script&lang=ts&"
import style0 from "./Artwork.vue?vue&type=style&index=0&id=756ce96e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports